import {combineReducers, Reducer} from 'redux'
import {CitiesState} from '@models/city'
import {CitiesActionTypes} from '@actions/city';


// Type-safe initialState!
export const initialState: CitiesState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case CitiesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, city) => {
                    obj[city.id] = {
                        ...city,
                        is_fetched: false,
                        ...(state[city.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case CitiesActionTypes.CREATE_SUCCESS: {
            const city = action.payload;
            return {
                ...state,
                [city.id]: city
            };
        }

        case CitiesActionTypes.UPDATE_SUCCESS: {
            const city = action.payload;
            return {
                ...state,
                [city.id]: {
                    ...state[city.id],
                    ...city
                }
            };
        }

        case CitiesActionTypes.FETCH_ITEM_SUCCESS: {
            const city = action.payload;
            return {
                ...state,
                [city.id]: {
                    ...state[city.id],
                    ...city,
                    is_fetched: true
                },
            };
        }

        case CitiesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.params.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case CitiesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case CitiesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.params.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case CitiesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case CitiesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case CitiesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case CitiesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case CitiesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case CitiesActionTypes.FETCH_SUCCESS:
        case CitiesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<CitiesState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as cityReducer}


//Selectors
export const getCitiesList = cities => cities.allIds.map(id => cities.byId[id]);

export const getCityById = (cities, id) => cities.byId[id];